import { FlexCell, FlexRow, FlexSpacer, IconButton, Text } from '@epam/loveship'
import { ReactComponent as CrossIcon } from '@epam/assets/icons/common/navigation-close-24.svg'

type SidebarPanelHeaderProps = {
  title: string
  onClose?: () => void
  withCloseIcon?: boolean
}

export const SidebarPanelHeader = ({
  title,
  onClose,
  withCloseIcon,
}: SidebarPanelHeaderProps) => {
  return (
    <FlexRow borderBottom padding="24">
      <Text size="48" font="sans-semibold">
        {title}
      </Text>

      <FlexSpacer />

      {withCloseIcon && (
        <FlexCell shrink={0} width="auto">
          <IconButton icon={CrossIcon} onClick={onClose} />
        </FlexCell>
      )}
    </FlexRow>
  )
}
